//Name: Kids Shoe Sizes
//Code: KIDS
//Age: Kids
//Gender: Null
const kidsShoeSizes = [
  { id: '179', values: [
    {region: "AU", name: "3-6mths"},
    {region: "NZ", name: "3-6mths"},
    {region: "US", name: "1"},
    {region: "UK", name: "0.5"},
    {region: "EU", name: "16"}
  ]},
  { id: '180', values: [
    {region: "AU", name: "6-12mths"},
    {region: "NZ", name: "6-12mths"},
    {region: "US", name: "2"},
    {region: "UK", name: "1"},
    {region: "EU", name: "17"}
  ]},
  { id: '181', values: [
    {region: "AU", name: "1"},
    {region: "NZ", name: "1"},
    {region: "US", name: "2"},
    {region: "UK", name: "1"},
    {region: "EU", name: "17"}
  ]},
  { id: '182', values: [
    {region: "AU", name: "2"},
    {region: "NZ", name: "2"},
    {region: "US", name: "3"},
    {region: "UK", name: "2"},
    {region: "EU", name: "18"}
  ]},
  { id: '116', values: [
    {region: "AU", name: "3"},
    {region: "NZ", name: "3"},
    {region: "US", name: "4"},
    {region: "UK", name: "3"},
    {region: "EU", name: "19"}
  ]},
  { id: '118', values: [
    {region: "AU", name: "4"},
    {region: "NZ", name: "4"},
    {region: "US", name: "5"},
    {region: "UK", name: "4"},
    {region: "EU", name: "20"}
  ]},
  { id: '120', values: [
    {region: "AU", name: "5"},
    {region: "NZ", name: "5"},
    {region: "US", name: "6"},
    {region: "UK", name: "5"},
    {region: "EU", name: "22"}
  ]},
  { id: '122', values: [
    {region: "AU", name: "6"},
    {region: "NZ", name: "6"},
    {region: "US", name: "7"},
    {region: "UK", name: "6"},
    {region: "EU", name: "23"}
  ]},
  { id: '124', values: [
    {region: "AU", name: "7"},
    {region: "NZ", name: "7"},
    {region: "US", name: "8"},
    {region: "UK", name: "7"},
    {region: "EU", name: "24"}
  ]},
  { id: '126', values: [
    {region: "AU", name: "8"},
    {region: "NZ", name: "8"},
    {region: "US", name: "9"},
    {region: "UK", name: "8"},
    {region: "EU", name: "25"}
  ]},
  { id: '146', values: [
    {region: "AU", name: "9"},
    {region: "NZ", name: "9"},
    {region: "US", name: "10"},
    {region: "UK", name: "9"},
    {region: "EU", name: "26"}
  ]},
  { id: '147', values: [
    {region: "AU", name: "10"},
    {region: "NZ", name: "10"},
    {region: "US", name: "11"},
    {region: "UK", name: "10"},
    {region: "EU", name: "27"}
  ]},
  { id: '148', values: [
    {region: "AU", name: "11"},
    {region: "NZ", name: "11"},
    {region: "US", name: "12"},
    {region: "UK", name: "11"},
    {region: "EU", name: "28"}
  ]},
  { id: '149', values: [
    {region: "AU", name: "12"},
    {region: "NZ", name: "12"},
    {region: "US", name: "13"},
    {region: "UK", name: "12"},
    {region: "EU", name: "29"}
  ]},
  { id: '150', values: [
    {region: "AU", name: "13"},
    {region: "NZ", name: "13"},
    {region: "US", name: "14"},
    {region: "UK", name: "13"},
    {region: "EU", name: "30"}
  ]}
];

export default kidsShoeSizes;



// WEBPACK FOOTER //
// ./src/data/kid-shoe-sizes.js